import React from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/UI";
import VaccineCalendar from "@/components/VaccineCalendar";
import { Inseminations } from "./vet/Inseminations";
import { Pregnancy } from "./vet/Pregnancy";
import { Births } from "./vet/Births";
import { Treatments } from "./vet/Treatments";
import { PerformanceScorecard } from "./vet/PerformanceScorecard";
import { VetStats } from "./vet/VetStats";
import { HerdExits } from "./vet/HerdExits";

export default function Vet() {
  const [sp] = useSearchParams();
  const tab = sp.get("t") || "inseminations";
  return (
    <div data-testid="vet-page">
      <PageHeader title="Veteriner Modülü" subtitle="Tohumlama, gebelik kontrolü, tedavi ve ilaç stoğu takibi." />
      {tab === "inseminations" && <Inseminations />}
      {tab === "pregnancy" && <Pregnancy />}
      {tab === "births" && <Births />}
      {tab === "treatments" && <Treatments />}
      {tab === "vaccines" && <VaccineCalendar />}
      {tab === "performance" && <PerformanceScorecard />}
      {tab === "stats" && <VetStats />}
      {tab === "herd-exit" && <HerdExits />}
    </div>
  );
}
